/* globals angular, _ */
(function () {
  "use strict";

  function IntegrationService(
    $q,
    $rootScope,
    $state,
    $timeout,
    $window,
    $mdDialog,
    PayPalResource,
    MercadoLivreResource,
    IntegrationResource,
    localStorageService,
    moment,
    PROVIDERS
  ) {
    var IntegrationService = {};
    var openedDomain = "https://tray.api.mandae.com.br";
    var trackedWindows = {};
    var timeOutInMs = 1000;
    var intervalInMs = 200;
    var popUp;

    function authorizeUser(slug) {
      var provider = IntegrationService.getProvider(slug);
      provider.isAuthorized = true;
    }

    function unauthorizeUser(slug) {
      var provider = IntegrationService.getProvider(slug);
      provider.isAuthorized = false;
    }

    function setAuthUrl(slug, url) {
      var provider = IntegrationService.getProvider(slug);
      provider.authUrl = url;
    }

    function disableLoading(slug) {
      var provider = IntegrationService.getProvider(slug);
      provider.isLoading = false;
    }

    function enableLoading(slug) {
      var provider = IntegrationService.getProvider(slug);
      provider.isLoading = true;
    }

    function registerListener() {
      var eventMethod = $window.addEventListener
        ? "addEventListener"
        : "attachEvent";
      var eventer = $window[eventMethod];
      var messageEvent =
        eventMethod === "attachEvent" ? "onmessage" : "message";

      function onAuthorizeBackMessage(event) {
        var origin = event.origin || event.originalEvent.origin;
        if (origin === openedDomain) {
          clearInterval($window.postMsgIntervalID);
          popUp.close();
          if (event.data.redirect) {
            if (event.data.provider === "mercadolivre") {
              $state.go("importar");
            } else {
              $state.go("import-sales", { provider: event.data.provider });
            }
            return;
          }
          $rootScope.$apply(authorizeUser(event.data.provider));
        }
      }

      eventer(messageEvent, onAuthorizeBackMessage, false);
    }

    function getAuthUrl(slug) {
      return IntegrationService.getProvider(slug).authUrl;
    }

    function openPopUp(providerSlug, redirectToSales) {
      var windowFeatures = "width=890,height=672";
      var redirect = redirectToSales || false;
      var authUrl = getAuthUrl(providerSlug);
      trackedWindows[providerSlug] = "";
      popUp = $window.open(null, providerSlug, windowFeatures);
      $window.postMsgIntervalID = setInterval(function () {
        popUp.postMessage({ redirect: redirect }, openedDomain);
      }, intervalInMs);
      registerListener();
      $timeout(function () {
        if (!trackedWindows[providerSlug]) {
          $window.open(authUrl, providerSlug, windowFeatures);
        }
      }, timeOutInMs);
    }

    function showAuthorizationModal(provider) {
      return $mdDialog.show({
        controller: "IntegrationModalCtrl",
        controllerAs: "ctrl",
        template: require("../../app/perfil/integration/modal/integration-modal.html"),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        resolve: {
          provider: function () {
            return provider;
          },
        },
      });
    }

    function authorizeAccount(slug) {
      var deferred = $q.defer();
      if (slug === "mercadolivre") {
        MercadoLivreResource.authorize()
          .$promise.then(function (data) {
            deferred.resolve(data);
          })
          .catch(function (err) {
            deferred.reject(err);
          });
        return deferred.promise;
      }
      if (slug === "paypal") {
        PayPalResource.authorize()
          .$promise.then(function (data) {
            deferred.resolve(data);
          })
          .catch(function (err) {
            deferred.reject(err);
          });
        return deferred.promise;
      }
      IntegrationResource.isAuthorized({ provider: slug })
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    }

    function getAllProviders() {
      return _.filter(PROVIDERS, { hasAuth: true });
    }

    IntegrationService.getProvider = function (slug) {
      var provs = getAllProviders();
      return _.find(provs, function (provider) {
        return provider.slug === slug;
      });
    };

    IntegrationService.getSales = function (slug, params) {
      var defaults = {
        dataInicio: moment().toISOString(),
        dataFim: moment().toISOString(),
        pagina: 1,
      };
      var opts = _.assign({}, defaults, params);
      var deferred = $q.defer();
      if (slug === "paypal") {
        PayPalResource.getTransactions(
          { provider: slug },
          {
            dataInicio: opts.startDate,
            dataFim: opts.finalDate,
            pagina: opts.pagina,
            status: opts.status,
          }
        )
          .$promise.then(function (data) {
            deferred.resolve(data);
          })
          .catch(function (err) {
            deferred.reject(err);
          });
        return deferred.promise;
      } else {
        if (slug === "traycorp") {
          IntegrationResource.getTransactionsTrayCorp(
            { provider: slug },
            {
              dataInicio: moment(opts.startDate, "YYYY-MM-DD").format(
                "YYYY-MM-DD"
              ),
              dataFim: moment(opts.finalDate, "YYYY-MM-DD").format(
                "YYYY-MM-DD"
              ),
              pagina: opts.pagina,
              status: opts.status,
            }
          )
            .$promise.then(function (data) {
              deferred.resolve(data);
            })
            .catch(function (err) {
              deferred.reject(err);
            });
          return deferred.promise;
        } else {
          IntegrationResource.getTransactions(
            { provider: slug },
            {
              dataInicio: opts.startDate,
              dataFim: opts.finalDate,
              pagina: opts.pagina,
              status: opts.status,
            }
          )
            .$promise.then(function (data) {
              deferred.resolve(data);
            })
            .catch(function (err) {
              deferred.reject(err);
            });
          return deferred.promise;
        }
      }
    };

    IntegrationService.tryAuthorizeAccount = function (slug) {
      enableLoading(slug);
      authorizeAccount(slug)
        .then(function () {
          disableLoading(slug);
          authorizeUser(slug);
        })
        .catch(function (err) {
          disableLoading(slug);
          unauthorizeUser(slug);
          if (err && err.data && err.data.auth_url) {
            // jshint ignore:line
            setAuthUrl(slug, err.data.auth_url); // jshint ignore:line
          }
        });
    };

    IntegrationService.tryAuthorizeAccountsBatch = function (providers) {
      const slugs = _.map(providers, "slug");

      // Ativa o loading para todos antes da chamada
      _.forEach(slugs, enableLoading);

      return IntegrationResource.authorizeBatch({ plataformas: slugs })
        .$promise
        .then(function (response) {
          _.forEach(response.autorizacoes, function (auth) {
            disableLoading(auth.plataforma);
            if (auth.autorizado) {
              authorizeUser(auth.plataforma);
            } else {
              unauthorizeUser(auth.plataforma);
            }
          });
          return response; // O retorno aqui resolve a promessa para quem chamou
        })
        .catch(function (err) {
          _.forEach(slugs, function (slug) {
            disableLoading(slug);
            unauthorizeUser(slug);
          });
          throw err; // Propaga o erro para ser tratado no componente, se necessário
        });
    };

    IntegrationService.connect = function (provider, redirectToSales) {
      if (provider.slug === "paypal" || provider.slug === "mercadolivre") {
        openPopUp(provider.slug, redirectToSales);
        return;
      }
      var promisse = showAuthorizationModal(provider);
      promisse.then(function (response) {
        if (response.data.auth_url) {
          setAuthUrl(provider.slug, response.data.auth_url);
          openPopUp(provider.slug, redirectToSales);
          return;
        }
        authorizeUser(response.slug);
        if (redirectToSales) {
          var stateName = provider.slug === "bling" ? "bling" : "import-sales";
          $state.go(stateName, { provider: response.slug });
        }
      });
    };

    IntegrationService.validate = function (sales) {
      var deferred = $q.defer();
      IntegrationResource.validate({ encomendas: sales })
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };

    IntegrationService.disconnect = function (slug) {
      var deferred = $q.defer();
      if (slug === "paypal") {
        PayPalResource.disconnect()
          .$promise.then(function (data) {
            deferred.resolve(data);
          })
          .catch(function (err) {
            deferred.reject(err);
          });
        return deferred.promise;
      }
      if (slug === "mercadolivre") {
        MercadoLivreResource.logoutML()
          .$promise.then(function (data) {
            deferred.resolve(data);
          })
          .catch(function (err) {
            deferred.reject(err);
          });
        return deferred.promise;
      }
      IntegrationResource.disconnect({ provider: slug })
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });

      return deferred.promise;
    };

    IntegrationService.createOrder = function (slug, packages) {
      var deferred = $q.defer();
      IntegrationResource.createOrder({ provider: slug }, packages)
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };

    IntegrationService.getEnabledProviders = function (betaFeatures) {
      var provs = getAllProviders();
      _.forEach(provs, function (provider) {
        var betaProvider = _.find(betaFeatures, function (bf) {
          return provider.slug === bf.codigo.replace(/[_-]/g, "");
        });
        if (betaProvider && !betaProvider.possuiAcesso) {
          provider.isDisabled = true;
        }
      });
      return _.reject(provs, function (pv) {
        return pv.isDisabled;
      });
    };

    IntegrationService.getOrderStatus = async (provider) => {
      return IntegrationResource.orderStatus({ provider }).$promise;
    };

    IntegrationService.setOrderStatus = async (provider, status) => {
      return IntegrationResource.setOrderStatus({ provider }, { status })
        .$promise;
    };

    IntegrationService.saveAutoDeliveryType = function (
      providerSlug,
      collection
    ) {
      var deferred = $q.defer();
      IntegrationResource.saveAutoDeliveryType(
        { provider: providerSlug },
        { dePara: collection }
      )
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };

    IntegrationService.defineSequenceVTEX = function (
      providerSlug,
      collection
    ) {
      var deferred = $q.defer();
      IntegrationResource.defineSequenceVTEX(
        { provider: providerSlug },
        { mapeiaSequenceNoCampoReferencia: collection }
      )
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };

    IntegrationService.getSequenceVTEX = function (providerSlug, collection) {
      var deferred = $q.defer();
      IntegrationResource.getSequenceVTEX({ provider: providerSlug })
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };

    IntegrationService.getConfigs = function (clientId, providerSlug) {
      var deferred = $q.defer();
      IntegrationResource.getConfigs({
        cliente: clientId,
        plataforma: providerSlug,
      })
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };

    IntegrationService.defineConfigs = function (configuracao) {
      var deferred = $q.defer();
      IntegrationResource.defineConfigs(configuracao)
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
          throw err;
        });
      return deferred.promise;
    };

    IntegrationService.getAutoDeliveryType = function (providerSlug) {
      var deferred = $q.defer();
      IntegrationResource.getAutoDeliveryType({ provider: providerSlug })
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };

    IntegrationService.removeAutoDeliveryType = function (providerSlug, Ids) {
      var deferred = $q.defer();
      IntegrationResource.removeAutoDeliveryType(
        { provider: providerSlug },
        { ids: Ids }
      )
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };

    IntegrationService.getAutoInsurance = function (providerSlug) {
      var deferred = $q.defer();
      IntegrationResource.getAutoInsurance({ provider: providerSlug })
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };

    IntegrationService.saveAutoInsurance = function (providerSlug, params) {
      var deferred = $q.defer();
      IntegrationResource.saveAutoInsurance({ provider: providerSlug }, params)
        .$promise.then(function (data) {
          deferred.resolve(data);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    };

    IntegrationService.authorize = async (provider, params) => {
      return IntegrationResource.authorize({ provider }, params).$promise;
    };

    return IntegrationService;
  }

  angular.module("mandaeApp").factory("IntegrationService", IntegrationService);
})();
